import React from 'react';
import { Button } from 'bumbag';

import { PAYMENT_PROVIDERS } from '@medipass/utils/constants';

import { ApplePayAvailabilityStatus, ApplePayPaymentRequest } from './applePay';
import ApplePayButton from './ApplePayButton';
import { canRenderGooglePayOption } from './googlePay';
import GooglePayButton from './GooglePayButton';
interface ApproveRejectButtonsProps {
  applePayPaymentRequest?: ApplePayPaymentRequest;
  applePayStatus?: ApplePayAvailabilityStatus;
  enableApplePay?: boolean;
  enableGooglePay?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  onApplePayError?: (...args: Array<any>) => any;
  onApplePaySuccess?: (...args: Array<any>) => any;
  onClickExternalPayment?: (...args: Array<any>) => any;
  onClickReject?: (...args: Array<any>) => any;
  showReject?: boolean;
  transaction?: Record<string, any>;
  isSelectedPaymentExpired?: boolean;
}

export function ApproveRejectButtons({
  applePayPaymentRequest,
  applePayStatus = 'unsupported',
  enableApplePay = true,
  enableGooglePay = true,
  isDisabled = false,
  isLoading = false,
  onApplePayError,
  onApplePaySuccess,
  onClickExternalPayment,
  onClickReject,
  showReject = false,
  transaction = undefined,
}: ApproveRejectButtonsProps) {
  const shouldShowGooglePayButton = enableGooglePay && canRenderGooglePayOption();

  return (
    <div className="space-y-2">
      {!shouldShowGooglePayButton && !enableApplePay && (
        <Button
          palette="secondary"
          disabled={isDisabled || isLoading}
          isLoading={isLoading}
          size="medium"
          type="submit"
          width="100%"
        >
          APPROVE
        </Button>
      )}
      {onClickExternalPayment && (
        <React.Fragment>
          {shouldShowGooglePayButton && (
            <GooglePayButton
              onClick={() =>
                onClickExternalPayment({
                  paymentProvider: PAYMENT_PROVIDERS.GOOGLE_PAY,
                })
              }
            />
          )}
          {transaction && enableApplePay && (
            <ApplePayButton
              onError={onApplePayError}
              paymentRequest={applePayPaymentRequest}
              status={applePayStatus}
              onSuccess={onApplePaySuccess}
            />
          )}
        </React.Fragment>
      )}
      {showReject && (
        <Button
          palette="danger"
          disabled={isLoading}
          size="medium"
          variant="outlined"
          onClick={onClickReject}
          width="100%"
        >
          REJECT
        </Button>
      )}
    </div>
  );
}
